export default __webpack_public_path__ + "static/media/favourite.283fbae1.jpg";